// DashboardAlertList.jsx
export default function DashboardAlertList({ alerts, onOpenAlert }) {
    if (!alerts || alerts.length === 0) {
        return (
            <div className="text-sm text-muted-foreground">
                No active alerts
            </div>
        );
    }

    return (

        <div className="space-y-2">
            <div className="mb-3 text-xs font-mono uppercase tracking-widest text-gray-400">
                Active Alerts
            </div>
            {alerts.map(alert => (
                <div
                    key={alert.id}
                    className="p-3 rounded border cursor-pointer hover:bg-bg-softer"
                    onClick={() => onOpenAlert(alert)}
                >
                    <div className="text-sm font-medium">
                        {alert.label}
                    </div>
                    <div className="text-xs text-muted-foreground">
                        {alert.type}
                    </div>
                </div>
            ))}
        </div>
    );
}